// Tasks module
import axios from "axios";
import store from "/src/store/index";
const resource_uri = "/listaragenda";
const grava_prontuario = "/prontuario";
const lista_prontuario = "/listarprontuario"
const visualiza_prontuario = "/mostrarprontuario"
const modelo_prontuario = "/modeloprontuario"

const state = {
  agendaDia: [],
  diaSelecionado: new Date(),
  permissao: {},
  permissaoProntuario: {},
  listaDeProntuarios: [],
  listaDeDocumentos: [],
  visualizarProntuarios: [],
  modeloProntuario: [],
  ExcluirProntuarioRetorno: [],
};

const getters = {
  getPermissao: (state) => state.permissao,
  getPermissao: (state) => state.permissaoProntuario,
  getAgendaDia: (state) => state.agendaDia,
  diaSelecionado: (state) => state.diaSelecionado,
  getPaciente: (state) => (Id) => {
    if (Id == null || Id == "") {
      return null;
    }
    var filtro = state.agendaDia.filter((t) => t.Id === Number(Id));
    if (filtro.length > 0) {
      return filtro[0];
    }
    return null;
  },
};

const actions = {
  async fetchAgendaDia({ commit }, { urlBackEnd, idMedico , dia , qtdDias , }) {
    
    const response = await axios.post(urlBackEnd+resource_uri,{
    "idMedico":idMedico,
    "data": dia,
    "qtdDias":0,
    "emailUsuario": store.state.configuracoes.email,
    "mostrarHVazio": false
},{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
     commit("setAgendaDia", response.data)
     const permissaoProntuario = await axios.get(urlBackEnd+"/dadosvisiveis",{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
     commit("setpermissaoProntuario", permissaoProntuario.data)
  },

  async gravaProntuario({ commit }, { urlBackEnd, chave, idMedico, emailUsuario, data, hora, texto , idpaciente,idquestionario}) {
    const response = await axios.post(urlBackEnd+grava_prontuario,{
      "chave": chave,  
      "idMedico":idMedico,
      "emailUsuario": emailUsuario,
      "data": data,
      "hora": hora,
      "texto": texto,
      "idpaciente": idpaciente,
      "idquestionario": idquestionario
},{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
     //commit("resposta", response.data)
  },

  async modeloDeProntuario({ commit }, { urlBackEnd, idMedico, emailUsuario}) {
    const response = await axios.post(urlBackEnd+"/modeloprontuario",{  
      "idMedico":idMedico,
      "emailUsuario": emailUsuario,
},{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
     commit("setmodeloProntuario", response.data)
  },

  async listarProntuario({ commit }, { urlBackEnd, idpaciente, emailUsuario}) {
    const response = await axios.post(urlBackEnd+lista_prontuario,{  
      "idpaciente":idpaciente,
      "emailusuario": emailUsuario,
},{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
     commit("setlistaDeProntuarios", response.data)
     return response.data; // Retorna os dados para uso no componente
  },

  async visualizarProntuario({ commit }, { urlBackEnd, idpaciente, idquestionario, idprontuario, idmedico, emailUsuario, telaorigem}) {
    const response = await axios.post(urlBackEnd+visualiza_prontuario,{  
      "idpaciente":idpaciente,
      "idquestionario":idquestionario,
      "idprontuario":idprontuario,
      "idmedico":idmedico,
      "emailusuario": emailUsuario,
      "telaorigem": telaorigem,
},{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
     commit("setvisualizarProntuarios", response.data)
    },
    async listarPaciente({ commit }, { urlBackEnd, nome, cpf, rg, email}) {
    const response = await axios.post(urlBackEnd+"/listarpaciente",{  
      "nome": nome,
      "cpf": cpf,
      "rg": rg,
      "email": email,
},{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
      return response.data; // Retorna os dados para uso no componente 
  },
  
  async dadosMedicoPaciente({ commit }, { urlBackEnd, idpaciente, idmedico}) {
    const response = await axios.post(urlBackEnd+"/medicopaciente",{  
      "idmedico":idmedico,
      "idpaciente":idpaciente,
},{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
     commit("setdadosMedicoPaciente", response.data)
     return response.data; // Retorna os dados para uso no componente
  },
///começa aqui

  async buscarPacientePorCodigo({ commit }, { urlBackEnd, idpaciente, idmedico, tipodoc }) {
    const response = await axios.post(urlBackEnd+"/listardocumentos",{  
      "idmedico":idmedico,
      "idpaciente":idpaciente,
      "tipodoc": tipodoc
},{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
     commit("setlistaDeDocumentos", response.data)
     return response.data; // Retorna os dados para uso no componente
  },

  async atualizarPrescricao({ commit }, { urlBackEnd, idPrescricao, idPrescricaoStatus, DocumentosK, idmedico, jsonP}) {
    const response = await axios.put(urlBackEnd+"/prescricao",{  
      idPrescricao: idPrescricao,
      idPrescricaoStatus: idPrescricaoStatus, // 2 significa que a prescrição foi concluída
      DocumentosK: DocumentosK, // Array de documentos
      idmedico: idmedico,
      jsonP: jsonP
},{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
     return response.data; // Retorna os dados para uso no componente
  },
  ///terminar aqui
  async iniciarPrescricao({ commit }, { urlBackEnd, dadosProntuario }) {
    try {
      const response = await axios.post(
        urlBackEnd,
        dadosProntuario,
        { headers: { 'Content-Type': 'application/json' } }
      );
      commit("setRespostaEnvioProntuario", response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async salvarPrescricao({ commit }, { urlBackEnd, retornoPrescricao, idmedico }) {
    const response = await axios.post(urlBackEnd + "/prescricao",{
      idmedico: idmedico,
      jsonP: retornoPrescricao, 
    },
      {
        headers: {
          Authorization: `Bearer ${store.state.configuracoes.tokenBack}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data; // Retorna os dados para uso no componente  
  },

  async excluirProntuario({ commit }, { urlBackEnd, idprontuario, idmedico, emailUsuario }) {
    try {
      const response = await axios.delete(urlBackEnd + "/prontuario", {
        headers: {
          Authorization: `Bearer ${store.state.configuracoes.tokenBack}`,
          'Content-Type': 'application/json'
        },
        data: {
          idprontuario: idprontuario,
          idmedico: idmedico,
          emailusuario: emailUsuario
        }
      });
  
      commit("setExcluirProntuarioRetorno", response.data);
    } catch (error) {
      //NÃO FAZ NADA AQUI
    }
  },
  ///aqui começa
  async enviarPrescricaoParaBackend({ commit }, { urlBackEnd, retornoPrescricao }) {
    const response = await axios.post(
      urlBackEnd,
      retornoPrescricao, 
      {
        headers: {
          //Authorization: `Bearer ${store.state.configuracoes.tokenBack}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data; // Retorna os dados para uso no componente
  },
  ///aqui termina
  
  async agendaStatus({ commit }, { urlBackEnd, idPaciente , status, emailUsuario }) {
    const response = await axios.post(urlBackEnd+"/status",{
      "chave": idPaciente,
      "status": status,
      "emailusuario": emailUsuario
},{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
  },

  async agendaPermissao({ commit }, { urlBackEnd }) {
    const response = await axios.get(urlBackEnd+"/dadosvisiveis",{ headers: { Authorization: `Bearer ${store.state.configuracoes.tokenBack}`, 'Content-Type': 'application/json' } });
    commit("setPermissao", response.data)
  },   
};

const mutations = {
  setAgendaDia: (state, agendaDia) => (state.agendaDia = agendaDia),
  setDiaSelecinado: (state, diaSelecionado) => (state.diaSelecionado = diaSelecionado),
  setPermissao: (state, permissao) => (state.permissao = permissao),
  setpermissaoProntuario: (state, permissaoProntuario) => (state.permissaoProntuario = permissaoProntuario),
  setlistaDeProntuarios: (state, listaDeProntuarios) => (state.listaDeProntuarios = listaDeProntuarios),
  setlistaDeDocumentos: (state, listaDeDocumentos) => (state.listaDeDocumentos = listaDeDocumentos),
  setvisualizarProntuarios: (state, visualizarProntuarios) => (state.visualizarProntuarios = visualizarProntuarios),
  setExcluirProntuarioRetorno: (state, ExcluirProntuarioRetorno) => (state.ExcluirProntuarioRetorno = ExcluirProntuarioRetorno),
  setmodeloProntuario: (state, modeloProntuario) => (state.modeloProntuario = modeloProntuario),
};

export default {
  state,
  actions,
  mutations,
  getters,
};
